import React, { Component } from "react";
// import { Link } from "react-router-dom";
import { connect } from "react-redux";

// import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  getPaginationGroupsList,
  groupAdd,
  SetParams,
  SetProfilePaginationParams
} from "../../../store/CompanySettings/users/actions";
import { Row, Col, Table, Button,Pagination,  PaginationItem,PaginationLink, } from "reactstrap";
import "./datatables.scss";

import Swal from "sweetalert2";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getPaginationGroupsList({ ...this.props.profilePaginationParams, page: 1 });
  }
  deleteRecord(id) {
    Swal.fire({
      icon: "error",
      text: "Permission not allowed!",
    });
  }
    openPage(pageNo) {
      this.props.SetProfilePaginationParams({ ...this.props.profilePaginationParams, page: pageNo });
      this.props.getPaginationGroupsList({ ...this.props.profilePaginationParams, page: pageNo });
    }

  render() {
    return (
      <Row>
        <Col xs={12}>
                      <Row>
                <Col xs={6} xl={6}>
                  <div className="text-left">
                    <h5 className="card-title-18">Profile information</h5>
                  </div>
                </Col>

                <Col xs={6} xl={6}>
                  <div className="d-flex flex-column align-items-end"> {/* Aligns button & pagination to the right */}
                    <Button
                      type="button"
                      color="primary"
                      className="waves-effect waves-light"
                      href="/AddProfile/0"
                    >
                      Add Profile
                    </Button>
                    
                    <div className="mt-2"> {/* Adds margin to move pagination below the button */}
                      <Pagination aria-label="Page navigation example">
                        <PaginationItem disabled={this.props.profilePaginationParams.page <= 1}>
                          <PaginationLink onClick={() => this.openPage(1)} first />
                        </PaginationItem>

                        {this.props.profilePaginationParams.page > 2 && (
                          <PaginationItem disabled={this.props.profilePaginationParams.page <= 2}>
                            <PaginationLink onClick={() => this.openPage(this.props.profilePaginationParams.page - 2)}>
                              {this.props.profilePaginationParams.page - 2}
                            </PaginationLink>
                          </PaginationItem>
                        )}
                        {this.props.profilePaginationParams.page > 1 && (
                          <PaginationItem disabled={this.props.profilePaginationParams.page === 1}>
                            <PaginationLink onClick={() => this.openPage(this.props.profilePaginationParams.page - 1)}>
                              {this.props.profilePaginationParams.page - 1}
                            </PaginationLink>
                          </PaginationItem>
                        )}

                        <PaginationItem active>
                          <PaginationLink onClick={() => this.openPage(this.props.profilePaginationParams.page)}>
                            {this.props.profilePaginationParams.page}
                          </PaginationLink>
                        </PaginationItem>
                        {this.props.profilePaginationParams.page + 1 <= this.props.profilePaginationParams.no_of_pages && (
                          <PaginationItem>
                            <PaginationLink onClick={() => this.openPage(this.props.profilePaginationParams.page + 1)}>
                              {this.props.profilePaginationParams.page + 1}
                            </PaginationLink>
                          </PaginationItem>
                        )}
                        {this.props.profilePaginationParams.page + 2 <= this.props.profilePaginationParams.no_of_pages && (
                          <PaginationItem>
                            <PaginationLink onClick={() => this.openPage(this.props.profilePaginationParams.page + 2)}>
                              {this.props.profilePaginationParams.page + 2}
                            </PaginationLink>
                          </PaginationItem>
                        )}

                        <PaginationItem disabled={this.props.profilePaginationParams.page === this.props.profilePaginationParams.no_of_pages}>
                          <PaginationLink onClick={() => this.openPage(this.props.profilePaginationParams.no_of_pages)} last />
                        </PaginationItem>
                      </Pagination>
                    </div>
                  </div>
                </Col>
              </Row>


          <Row>
            
          </Row>
          <Row>
            <Col xs={12}>
              <div className="table-responsive m-0 mt-2">
                <Table bordered hover className="mb-0 p-0 table-centered">
                  <thead className="bg-light text-center">
                    <tr>
                      <th className="nowrap">S.No</th>
                      <th className="nowrap">Profile</th>
                      <th className="nowrap">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.values(this.props.paginationGroupList)?.map((group, key) => (
                      <tr key={key}>
                        <td className="text-center">
                          {this.props.profilePaginationParams.page_size * (this.props.profilePaginationParams.page - 1) + (key + 1)}
                          </td>
                        <td>{group.name}</td>

                        <td className=" text-center">
                          <Button
                            outline
                            type="button"
                            color="success"
                            className="waves-effect waves-light mr-2"
                            href={"/AddProfile/" + group.id}
                            // onClick={() => {
                            //   this.props.getRowUserData(group.id);
                            // }}
                          >
                            <i className="mdi mdi-border-color"></i>
                          </Button>
                          <Button
                            outline
                            type="button"
                            color="danger"
                            className="waves-effect waves-light"
                            onClick={() => {
                              this.deleteRecord(group.id);
                            }}
                          >
                            <i className="mdi mdi-delete-forever"></i>
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

const mapStatetoProps = (state) => {
  const { profilePaginationParams,rowlist, groupsList,paginationGroupList, model, message, rowdata, groupdata } =
    state.Users;
  return { message, Error, rowlist, groupsList,paginationGroupList, model, rowdata, groupdata ,profilePaginationParams};
};

export default connect(mapStatetoProps, { getPaginationGroupsList, groupAdd ,SetParams,SetProfilePaginationParams})(Profile);
